import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useUser(): RootState['user'] {
    const user = useSelector<RootState, RootState['user']>(({ user }) => user)

    return user
}
